import type { GetOrganizationDevicesResponse } from "@somewear/api";
import { signedOut } from "@somewear/auth";
import { grpc, someGrpc } from "@somewear/grpc";
import type { ActionSetEpic } from "@somewear/model";
import { createActionSetEpicHandler } from "@somewear/model";
import { combineEpics, Epic, ofType } from "redux-observable";
import { of } from "rxjs";
import { filter, mergeMap, takeUntil } from "rxjs/operators";

import {
	emitOrganizationDevicesFetchedFromServer,
	organizationDeviceActions,
} from "./organizationDeviceActions";

const fullfilledWorkspaceDevicesEpic: Epic = (action$) =>
	action$.pipe(
		filter(organizationDeviceActions.getDevices.fulfilled.match),
		mergeMap((response) => {
			return of(emitOrganizationDevicesFetchedFromServer(response.payload.data));
		}),
		takeUntil(action$.pipe(ofType(signedOut.type))),
	);

const getOrganizationDevicesEpic: ActionSetEpic<void, GetOrganizationDevicesResponse.AsObject> = (
	action$,
	state$,
) => {
	return createActionSetEpicHandler(action$, state$, organizationDeviceActions.getDevices, () =>
		grpc.prepareRequest(someGrpc.fetchOrganizationDevices),
	);
};

export const organizationDeviceEpics = combineEpics<any, any, any>(
	getOrganizationDevicesEpic,
	fullfilledWorkspaceDevicesEpic,
);
